import { Stack, Typography } from '@mui/material'
import { SearchIcon } from '$common/icons'
import { t } from '$i18n'

export const EmptySearchResult = () => (
  <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
    <SearchIcon sx={{ width: '58px', height: '58px', color: 'lightGray' }} />

    <Typography variant="subtitle1" color="gray">
      {t('emptyState.noResultFound')}
    </Typography>

    <Typography variant="body2" color="gray">
      {t('emptyState.searchHint')}
    </Typography>
  </Stack>
)
